import { LANGS, LANG_LABELS, type Lang, useT } from './index';

/** Seletor de idioma compacto (pt/es) para a barra de status do PWA. */
export function LanguageSelector() {
  const { lang, setLang, t } = useT();
  return (
    <select
      aria-label={t('common.language')}
      value={lang}
      onChange={(e) => setLang(e.target.value as Lang)}
      className="rounded-md border border-line bg-surface px-2 py-1 text-xs text-muted"
    >
      {LANGS.map((option) => (
        <option key={option} value={option}>
          {LANG_LABELS[option]}
        </option>
      ))}
    </select>
  );
}
